import { $ } from '../third-party-imports';
export function setPhoneNumberfromHeader() {
    var phone = $($(".anchor_desktop_phone_number").clone()[1])?.children()?.remove()?.end()?.text()?.trim();
    if($('.service-coupon-section .phone-number').length) { 

       $('.service-coupon-section .phone-number').html(`
       <img src="/us/en-us/mr-handyman/_assets/images/phone-red.svg" alt="" width="13" height="27" fetchpriority="low" loading="lazy"> ${phone}`)
       $('.service-coupon-section .phone-number').attr('href', 'tel:' + phone);
    }
}